// extracted by mini-css-extract-plugin
export default {"StoryCheckerDetail":"StoryCheckerDetailDark__StoryCheckerDetail___2A4NI"};